export default __webpack_public_path__ + "static/media/teamwork.2b76817f.svg";